export default __webpack_public_path__ + "static/media/close_icon.fcbfc22b.svg";